export enum Role {
    ROLE_ADMIN = 1,
    ROLE_CINEMA = 2,
    ROLE_DISTRIBUTOR = 3,
    ROLE_USER = 4,
    ROLE_INTERNAL = 5,
    ROLE_CHAIN_ADMIN = 16
}

export enum RoleName {
    ADMIN = 'admin',
    CINEMA = 'cinema',
    DISTRIBUTOR = 'distributor',
    USER = 'user',
    CHAIN_ADMIN = 'chain-admin'
}
